import React, { useEffect } from 'react';
import { useExpiry } from '../../context/ExpiryContext';
import ExpiredAlert from '../UI/ExpiredAlert';

const GlobalExpiryHandler = () => {
  const { isExpired, expiryMessage, triggerExpiry, clearExpiry } = useExpiry();

  useEffect(() => {
    const handleSubscriptionExpired = (event) => {
      const { message } = event.detail;
      triggerExpiry(message);
    };

    // Listen for global subscription expired events
    window.addEventListener('subscription-expired', handleSubscriptionExpired);

    return () => {
      window.removeEventListener('subscription-expired', handleSubscriptionExpired);
    };
  }, [triggerExpiry]);

  return (
    <ExpiredAlert 
      isOpen={isExpired} 
      onClose={clearExpiry}
      message={expiryMessage}
    />
  );
};

export default GlobalExpiryHandler;
